module.exports = __webpack_public_path__ + "img/manage.de1175ce.jpg";